<div class="zn-form" [formGroup]="form">
    <fieldset>
    <div class="row">
        <div class="col-6">
        <div class="form-control-container">
            <label class="form-label" for="PlantingDate">
                {{`${localizationResource}::Stand.PlantingDate`| abpLocalization}}
                <span class="form-label-required">*</span>
            </label>
            <input
                id="PlantingDate"
                class="form-control"
                [ngClass]="{
                'is-valid': form.get('PlantingDate')?.valid && (form.get('PlantingDate')?.touched || form.get('PlantingDate')?.dirty),
                'is-invalid': fieldInvalid('PlantingDate') && !dp.isOpen()
                }"
                ngbDatepicker
                [markDisabled]="disabledDates"
                [maxDate]="today"
                #dp="ngbDatepicker"
                #plantingDateInput
                appDateMask
                formControlName="PlantingDate"
                [placeholder]="`${localizationResource}::DateFormat` | abpLocalization"
                tabindex="0"
                (click)="dp.toggle()"
                (blur)="onPlantingDateBlur(plantingDateInput)"
                />
                @if (fieldInvalid('PlantingDate')) {
                @if (form.get('PlantingDate')?.hasError('required')) {
                    <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
                }
                @if (form.get('PlantingDate')?.hasError('futureDate')) {
                    <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorFutureDate` | abpLocalization}}</small>
                }
                @if (form.get('PlantingDate')?.hasError('invalidDate')) {
                    <small class="invalid-feedback d-block">{{`${localizationResource}::InvalidDateFormat` | abpLocalization}}</small>
                }
                }
        </div>
        </div>  

        <div class="col-6">
        <div class="form-control-container">
            <div class="form-control-container form-check-inner-container form-check">
            <input 
                id="OwnPlantation"
                class="form-check-input order-first check-lg"
                type="checkbox"
                formControlName="OwnPlantation"
            />
            <label class="form-label" for="OwnPlantation">
                {{`${localizationResource}::Stand.OwnPlantation`| abpLocalization}}
            </label>
            </div>
        </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="form-control-container">
                <label class="form-label" for="Spacing">
                    {{`${localizationResource}::Stand.Spacing`| abpLocalization}}
                    <span class="form-label-required">*</span>
                </label>
                <zn-single-select
                    id="Spacing"
                    [options]="spacingOptions()"
                    [optionsLoader]="spacingsLoader"
                    [showSearch]="true"
                    formControlName="Spacing"
                    [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                    [localizationResource]="localizationResource"
                    [openUp]="false"
                ></zn-single-select>
                @if (fieldInvalid('Spacing')) {
                    @if(form.get('Spacing')?.hasError('required')) {
                        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
                    }
                }
            </div>
        </div>

        <div class="col-6">
            <div class="form-control-container">
                <label class="form-label" for="PlantingType">
                    {{`${localizationResource}::Stand.PlantingType`| abpLocalization}}
                    <span class="form-label-required">*</span>
                </label>
                <zn-single-select
                    id="PlantingType"
                    [options]="plantingTypeOptions()"
                    [optionsLoader]="plantingTypesLoader"
                    [showSearch]="true"
                    formControlName="PlantingType"
                    [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                    [localizationResource]="localizationResource"
                    [openUp]="false"
                ></zn-single-select>
                @if (fieldInvalid('PlantingType')) {
                    @if (form.get('PlantingType')?.hasError('required')) {
                        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
                    }
                }
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="form-control-container">
                <label class="form-label" for="GeneticMaterial">
                    {{`${localizationResource}::Stand.GeneticMaterial`| abpLocalization}}
                    <span class="form-label-required">*</span>
                </label>
                <zn-single-select
                    id="GeneticMaterial"
                    [options]="geneticMaterialOptions()"
                    [optionsLoader]="geneticMaterialsLoader"
                    [showSearch]="true"
                    formControlName="GeneticMaterial"
                    [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                    [localizationResource]="localizationResource"
                    [openUp]="false"
                ></zn-single-select>
                @if (fieldInvalid('GeneticMaterial')) {
                    @if (form.get('GeneticMaterial')?.hasError('required')) {
                        <small class="invalid-feedback d-block">{{`${localizationResource}::DefaultErrorRequired` | abpLocalization}}</small>
                    }
                }
            </div>
        </div>

        <div class="col-6">
            <div class="form-control-container">
                <label class="form-label" for="Species">
                    {{`${localizationResource}::Stand.Species`| abpLocalization}}
                    <span class="form-label-required">*</span>
                </label>
                <input
                    class="form-control" 
                    formControlName="Species" 
                    id="Species"
                />
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="form-control-container">
                <div class="form-control-container form-check-inner-container form-check">
                    <input
                        id="PlantingCompleted"
                        class="form-check-input order-first check-lg"
                        type="checkbox"
                        formControlName="PlantingCompleted"
                    />
                    <label class="form-label" for="PlantingCompleted">
                        {{`${localizationResource}::Stand.PlantingCompleted`| abpLocalization}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    </fieldset>
</div>
